/**
 * filesTransformStore — Zustand-хранилище конфигурации Files Transform.
 *
 * P1.4 (2026-08-14): state поднят с local useState FilesTransformPage в
 * общий store, чтобы единая workspace-library могла применять/сохранять
 * files_transform-секцию наравне с search/generation/matching.
 *
 * НЕ персистится (localStorage) — конфиг привязан к конкретному dataset
 * и ephemeral по своей природе (sheet/renames/selected живёт до Save на
 * бэкенд). Выбор «remember» здесь был бы misleading.
 *
 * Shape зеркалит то, чего ждут buildFilesTransformLibrarySnapshot /
 * applyFilesTransformLibrarySnapshot (см. librarySnapshots.ts).
 */
import { create } from 'zustand';

export interface FilesTransformState {
  pickedSheet: string | null;
  renames: Record<string, string>;
  /** Выбранные колонки (effective names). Snapshot пишет как selected_columns: string[]. */
  selectedColumns: string[];
  setPickedSheet: (sheet: string | null) => void;
  setRenames: (renames: Record<string, string>) => void;
  setSelectedColumns: (cols: string[]) => void;
  toggleColumn: (col: string) => void;
  reset: () => void;
}

const DEFAULTS = {
  pickedSheet: null as string | null,
  renames: {} as Record<string, string>,
  selectedColumns: [] as string[],
};

export const useFilesTransformStore = create<FilesTransformState>((set) => ({
  ...DEFAULTS,
  setPickedSheet: (sheet) => set({ pickedSheet: sheet }),
  setRenames: (renames) => set({ renames }),
  setSelectedColumns: (cols) => set({ selectedColumns: cols }),
  toggleColumn: (col) =>
    set((s) => ({
      selectedColumns: s.selectedColumns.includes(col)
        ? s.selectedColumns.filter((c) => c !== col)
        : [...s.selectedColumns, col],
    })),
  reset: () => set({ ...DEFAULTS }),
}));